"use client";
import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { useRef } from "react";
import { styles } from "./SizeWizardStyles";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { focusOutline } from "@ecco/ui/css/focus";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { handleKeyboardActivation } from "@lib/utils/a11y/keyboardActivation";
import { useSizeWizardText } from "./useSizeWizardText";
import { AnalyticsClient } from "@lib/analytics/AnalyticsClient";

interface SizeWizardVBProps {
    selectedSize?: number;
    sizeGuideOpenProps;
}

const SizeWizardVB = ({ selectedSize, sizeGuideOpenProps }: SizeWizardVBProps) => {
    const { showModal } = useGlobalModalContext();
    const { fullText } = useSizeWizardText(selectedSize);
    const returnFocusRef = useRef<HTMLDivElement>(null);

    const handleInfoClick = () => {
        const numericSize = typeof selectedSize === "number" ? selectedSize : Number(selectedSize);
        showModal(ModalTypes.sizeGuide, {
            ...sizeGuideOpenProps,
            fitFeedbackSelectedSize: numericSize,
            finalFocusRef: returnFocusRef,
        });

        AnalyticsClient.sizeWizard();
    };

    return (
        <Box
            tabIndex={0}
            role="button"
            ref={returnFocusRef}
            onClick={handleInfoClick}
            id="size-wizard-action-button"
            minH={selectedSize ? "auto" : "36px"}
            _focus={{ outline: "none", boxShadow: "none" }}
            _focusVisible={{ ...focusOutline, boxShadow: "none" }}
            style={{ ...styles.sizeWizard.infoWrapper, cursor: "pointer" }}
            onKeyDown={(e) => handleKeyboardActivation(e, handleInfoClick)}
        >
            <ECCOIcon name="info" />
            <Text
                _hover={{ textDecoration: "underline" }}
                style={{
                    ...styles.sizeWizard.infoText,
                }}
            >
                {fullText}
            </Text>
        </Box>
    );
};

export default SizeWizardVB;
